import { z } from 'zod';

/**
 * Every table a person can sort, by a stable id (also the key of the person's saved sort, APP-149):
 * the Home queue card, the Queue page's table across its views, (APP-233) All Spot awards and
 * (APP-241) the Spot Committee's queue. More are added as tables gain sorting.
 */
export const SortTableId = z.enum(['home_queue', 'queue', 'spot_all', 'spot_committee']);
export type SortTableId = z.infer<typeof SortTableId>;

/** A table's sort: a column's short id, and its direction. */
export const TableSort = z
  .object({
    column: z.string().regex(/^[a-z][A-Za-z0-9_]{0,39}$/, 'not a column id'),
    dir: z.enum(['asc', 'desc']),
  })
  .strict();
export type TableSort = z.infer<typeof TableSort>;

/** The order Waiting on you opens in on Home (APP-149 D7). Oldest first unless the person changes it. */
export const WaitingOrder = z.enum(['oldest', 'newest', 'role']);
export type WaitingOrder = z.infer<typeof WaitingOrder>;

/**
 * How a sorted table opens next time (APP-149 D7): in its default order each time ('start'), or
 * the way the person last sorted it, on any device ('keep').
 */
export const TableSortMode = z.enum(['start', 'keep']);
export type TableSortMode = z.infer<typeof TableSortMode>;
